import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const root = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xs});
  flex-direction: row;
  margin: var(${spacing.sm}) 0 0 0;
  padding: var(${spacing.xs}) 0;
  color: var(${colors.content.positive});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  border-top: 1px solid var(${colors.stroke.default});
`;
